import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../Navbar';
import './Pricing.css';
import { API_ENDPOINTS } from '../config/api';
import { authFetch } from '../utils/authFetch';

const PricingSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [displayPlan, setDisplayPlan] = useState('your selected plan');

  const restoreFormData = () => {
    
    const backupSources = [
      {
        url: localStorage.getItem('backup_pendingUrl') || localStorage.getItem('stripe_backup_url'),
        keywordsList: localStorage.getItem('backup_pendingKeywordsList') || localStorage.getItem('stripe_backup_keywords'),
        keyword: localStorage.getItem('backup_pendingKeyword') || localStorage.getItem('stripe_backup_keyword'),
        source: 'localStorage'
      },
      {
        url: sessionStorage.getItem('form_backup_url'),
        keywordsList: sessionStorage.getItem('form_backup_keywords'),
        keyword: sessionStorage.getItem('form_backup_keyword'),
        source: 'sessionStorage'
      }
    ];

    let restoredData = null;
    for (const backup of backupSources) {
      if (backup.url || backup.keywordsList || backup.keyword) {
        restoredData = backup;
        break;
      }
    }

    if (restoredData) {
      
      if (restoredData.url && !localStorage.getItem('pendingUrl')) {
        localStorage.setItem('pendingUrl', restoredData.url);
      }
      
      if (restoredData.keywordsList && !localStorage.getItem('pendingKeywordsList')) {
        localStorage.setItem('pendingKeywordsList', restoredData.keywordsList);
      }
      
      if (restoredData.keyword && !localStorage.getItem('pendingKeyword')) {
        localStorage.setItem('pendingKeyword', restoredData.keyword);
      }

      // we can also restore user info here if we want
      const backupUserEmail = localStorage.getItem('backup_userEmail') || sessionStorage.getItem('backup_userEmail');
      const backupIsLoggedIn = localStorage.getItem('backup_isLoggedIn') || sessionStorage.getItem('backup_isLoggedIn');
      
      if (backupUserEmail && !localStorage.getItem('userEmail')) {
        localStorage.setItem('userEmail', backupUserEmail);
      }
      
      if (backupIsLoggedIn && !localStorage.getItem('isLoggedIn')) {
        localStorage.setItem('isLoggedIn', backupIsLoggedIn);
      }

      return true; 
    } else {
      return false; 
    }
  };

  useEffect(() => {
    
    const wasRestored = restoreFormData();
    
    
    const userEmail = localStorage.getItem('userEmail');
    
    const fetchPlanType = async () => {
      try {
        const response = await authFetch(
          `${API_ENDPOINTS.GET_USER_INFO}?user_id=${encodeURIComponent(userEmail)}`
        );
        const data = await response.json();
        let rawBody = data.body || data;
        rawBody = rawBody.replace(/^"|"$/g, '');
        let jsonStr = rawBody.replace(/User information:\s*/, '').replace(/'/g, '"');
        jsonStr = jsonStr.replace(/Decimal\("(\d+)"\)/g, '$1');
        const parsed = JSON.parse(jsonStr);
        const planType = parsed.Item?.PlanType?.toLowerCase();
        
        // Map planType to readable name
        if (planType.includes('free')) {
          setDisplayPlan('Free/Weekly Plan');
        } else if (planType.includes('casual')) {
          setDisplayPlan('Casual Job Seeker/ Daily Search Plan');
        } else if (planType.includes('active') || planType.includes('hourly')) {
          setDisplayPlan('Active Job Seeker/ Hourly Search Plan');
        } else if (planType.includes('power') || planType.includes('ultra')) {
          setDisplayPlan('Power Job Seeker/ Ultra Search Plan');
        } else {
          setDisplayPlan(planType);
        }
      } catch (error) {
        console.error('Error fetching plan type:', error);
      }
    };

    if (userEmail) {
      fetchPlanType();
    }
  }, []);

  const handleContinue = () => {
    navigate('/tool');
  };

  const cleanupBackups = () => {
    const backupKeys = [
      'backup_pendingUrl', 'stripe_backup_url',
      'backup_pendingKeywordsList', 'stripe_backup_keywords',
      'backup_pendingKeyword', 'stripe_backup_keyword',
      'backup_userEmail', 'backup_isLoggedIn'
    ];
    
    const sessionBackupKeys = [
      'form_backup_url', 'form_backup_keywords', 'form_backup_keyword',
      'backup_userEmail', 'backup_isLoggedIn'
    ];
    
    backupKeys.forEach(key => localStorage.removeItem(key));
    
    sessionBackupKeys.forEach(key => sessionStorage.removeItem(key));
    
  };

  useEffect(() => {
    return () => {
      setTimeout(cleanupBackups, 1000);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="pricing-success-container">
        <div className="pricing-success-box">
          <h1>Thank You for Your Purchase!</h1>
          <p>You have successfully subscribed to the <strong>{displayPlan}</strong>.</p>
          <p className="success-note">
            Your form data has been preserved and you can continue your job search right where you left off.
          </p>
          <button
            onClick={handleContinue}
            className="continue-search-button"
          >
            Continue Job Search
          </button>
        </div>
      </div>
    </>
  );
};

export default PricingSuccess;